import styled from 'styled-components';

export const WhiteBackgroundWrapper = styled.div`
  /* Glassy effect */
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 1400px;
  margin: 2rem auto;

  @media (max-width: 768px) {
    padding: .05rem;
    margin: .5rem;
  }
`;

export const ContentWrapper = styled.div`
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 2rem;
  margin: 2rem;
  overflow-y: auto;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 1rem;
    margin: 1rem;
  }
`;

export const ContactSection = styled.section`
  margin-top: 3rem;
  padding: 0 1rem;

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    color: ${(props) => props.theme.primary};
    text-align: center;
  }

  p {
    margin-bottom: 2.5rem;
    line-height: 1.8;
    color: ${(props) => props.theme.text};
    text-align: center;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const ContactForm = styled.form`
  max-width: 500px;
  margin: 2rem auto 0 auto;
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: 0.5rem;
    color: ${(props) => props.theme.text};
    font-weight: bold;
  }

  input,
  select,
  textarea {
    margin-bottom: 1.5rem;
    padding: 0.75rem;
    border-radius: 5px;
    border: 1px solid ${(props) => props.theme.border};
    font-size: 1rem;
    color: ${(props) => props.theme.text};
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    font-family: inherit;
  }

  select {
    background: #fff;
  }

  button {
    align-self: center;
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: bold;
    color: var(--color-button-text);
    background: var(--color-new-button-active);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      background: var(--color-new-button-active-hover);
      transform: translateY(-2px);
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:focus {
      outline: 2px solid var(--color-highlight);
      outline-offset: 2px;
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
      background: var(--color-disabled);
      color: #666;
      cursor: not-allowed;
    }
  }
`;

export const ContactDetails = styled.div`
  max-width: 600px;
  margin: 3rem auto 0 auto;
  text-align: center;

  h2 {
    font-size: 1.75rem;
    margin-bottom: 1.5rem;
    color: ${(props) => props.theme.primary};
  }

  p {
    margin-bottom: 1rem;
    line-height: 1.8;
    color: ${(props) => props.theme.text};

    strong {
      color: ${(props) => props.theme.primary};
    }
  }
`;